import _curry from "ramda/es/curry";
import _equals from "ramda/es/equals";
import _view from "ramda/es/view";
import _pipe from "ramda/es/pipe";

var lensEquals = function (lens, comp, obj) {
  return _pipe(_view(lens), _equals(comp))(obj);
};

export default _curry(lensEquals);